module.exports = {"failed":"These credentials do not match our records.","throttle":"Too many login attempts. Please try again in :seconds seconds."};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/auth.php
// module id = rHkG
// module chunks = 1